/* eslint-disable no-console */
import FeatureFlagService from 'services/feature-flag/feature-flag';
import React, { useEffect } from 'react';
import logger from 'services/logger';
import { Hub, Auth } from 'aws-amplify';
import gqlMutationPostLogin from 'graphql/mutations/post-login';
import { withApollo } from 'react-apollo';
import { authEvents, amplifyChannels } from 'app-constants';

import { Sentry, captureException } from '../../services/sentry';

function doSignIn(client) {
  logger.log('Trying to remember who you are...');
  client
    .mutate({
      mutation: gqlMutationPostLogin
    })
    .then((resp) => {
      logger.log(
        `login successful for user [${resp.data.postLogin.loginUser.name}]`
      );
    })
    .catch((error) => {
      // Error happen, just throw error
      captureException(error);
      logger.error(error);
    });
}

function WithAuthEventHandlerHOC(Component) {
  const HOC = (props) => {
    const { client } = props;
    const listener = (emit) => {
      if (emit.payload.event === authEvents.SIGN_IN) {
        doSignIn(client);
        if (emit.payload.data && emit.payload.data.attributes) {
          // Init feature flag after auth event emit
          FeatureFlagService.init(emit.payload.data.attributes.email);
        }
      }
      logger.log(`[event][${emit.channel}][${emit.payload.event}]`);
    };

    useEffect(() => {
      Auth.currentAuthenticatedUser({ bypassCache: false })
        .then((user) => {
          // Init feature flag for page load
          Sentry.setUser({
            email: user.attributes.email,
            username: user.username
          });
          FeatureFlagService.init(user.attributes.email);
        })
        .catch((error) => {
          captureException(error);
          logger.log(error);
        });
      Hub.listen(amplifyChannels.AUTH, listener);
      return function cleanup() {
        Hub.remove(amplifyChannels.AUTH, listener);
      };
    });

    return (
      <div data-testid="auth-event-handler">
        <Component {...props} />
      </div>
    );
  };
  return withApollo(HOC);
}

export default WithAuthEventHandlerHOC;
